export const getDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  wallboxIndex: string | number = ':wallboxIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/wallbox/${wallboxIndex}`
  }

  return `/installation/${installationId}/${storageId}/properties/wallbox/${wallboxIndex}`
}

export const getFarmDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  childStorageId: string | number = ':childStorageId',
  wallboxIndex: string | number = ':wallboxIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/wallbox`
  }

  return `/installation/${installationId}/${storageId}/properties/wallbox/${childStorageId}/${wallboxIndex}`
}

export const getBaseRoute = (installationId: string | number = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/wallbox`
  }
  return `/installation/${installationId}/${storageId}/properties/wallbox`
}
